/**
 * @generated SignedSource<<c18070a7794add5132d60ab41120cd03>>
 * @relayHash bda8142f8880682eab0a06d499b8c427
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a25341447d6b153cb0670ee92efeb0509c6faf617380740ff62e000b5a32d86d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a25341447d6b153cb0670ee92efeb0509c6faf617380740ff62e000b5a32d86d",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
